import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('permissions/roles', 'roles');

tbl.add(new Xtc('title', 'Title'))
tbl.add(new Xtc('actions', 'Actions').noSort().renderSlot('act'))

export default tbl;

